import { withTranslation } from "react-i18next";
import { Sidebar as SidebarDefinition } from "./Sidebar";

export const Sidebar = withTranslation()(SidebarDefinition);
